import React, { useState, useEffect, useRef, useMemo } from "react";
import { Container, Button, Row, Col, Tabs, Tab, Nav, CloseButton } from "react-bootstrap";
import { createBrowserHistory } from "history";
import Tooltip from "@mui/material/Tooltip";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../static/css/dropdown.css";
import { showConfirm } from "react-confirm-prompt";
import { Typography, Box } from "@mui/material";
import "../../static/css/pendingorders.css";
import { DataGrid, GridToolbar, gridClasses } from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import "../../static/css/App.css";
import omsapi from "../../services/omsapi";
import branchApi from "../../services/branchapi";
import constantType from "../constantType";
import SearchableDropdown from "../components/SearchableDropdown";
import { selectCurrentUser, selectAccessData } from "../../features/auth/authSlice";
import { useSelector } from "react-redux";
import DynamicBreadcrumb from "../header/breadcrumb";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import InvoiceModal from "./InvoiceModal";
import moment from "moment/moment";
import InvoicePrintModal from "./InvoicePrintModal";
import OrderTabs from "./components/orderTabs";
import OrderButtons from "./components/orderButtons";
import OrderPayFields from "./components/orderPayFields";
import OrderModal from "./components/OrderModal";
library.add(fas);

const OrderTable = ({ status, isActive = true, action = null }) => {
  const history = createBrowserHistory();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalOrders, setTotalOrders] = useState(0);
  const user = useSelector(selectCurrentUser);
  const accessData = useSelector(selectAccessData);
  const roleId = JSON.parse(accessData).roleId;
  let intBranchId = user.branchId;
  if (roleId === 1 || roleId === 2 || roleId === 12 || roleId === 10 || roleId === 8) {
    intBranchId = 0;
  }
  const [branchId, setBranchID] = useState(intBranchId);
  const [branchName, setBranchName] = useState("All");
  const [allBranches, setAllBranches] = useState([]);
  const [boxBranchName, setboxBranchName] = useState(branchName);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [refreshTable, setRefreshTable] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [closeNotes, setCloseNotes] = useState("");
  const [handoverName, setHandoverName] = useState("");
  const [handoverMob, setHandoverMob] = useState("");
  const [deliBoxEnable, setDeliBoxEnable] = useState(null);
  const [notesText, setNotesText] = useState("Enter Reason");
  const [errors, setErrors] = useState({});
  const [invoiceId, setInvoiceId] = useState(0);
  const [delInvoiceId, setDelInvoiceId] = useState(0);
  const [invModal, setInvModal] = useState(false);
  const [curStatus, setCurStatus] = useState(status);
  const [curAction, setCurAction] = useState(action);
  const [curActive, setCurActive] = useState(isActive);
  const [pushUrl, setPushUrl] = useState(null);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [invoiceAllowAmount, setInvoiceAllowAmount] = useState(0);
  const [orderData, setOrderData] = useState([]);
  const [currentPaymentAmount, setCurrentPaymentAmount] = useState(0);
  const [invPrintModal, setInvPrintModal] = useState(false);
  const [printInvoices, setPrintInvoices] = useState([]);
  const [modelContent, setModelContent] = useState({
    title: "Update the Reason",
    buttonText: "Cancel Order",
    handleChangeType: "cancel",
  });
  const inputArr = [
    {
      id: 1,
      paymentModeValue: 0,
      paymentValue: "",
    },
  ];
  const [paymentFields, setPaymentFields] = useState(inputArr);
  const buttonName = constantType.orderButton[curStatus] || "Confirm Order";
  const [searchKey, setSearchKey] = useState("");
  const [deliveryType, setDeliveryType] = useState("");
  const [placedType, setPlacedType] = useState("");
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dateFilterField, setDateFilterField] = useState("order_posteddate");
  const [isTakeawaySubmitting, setIsTakeawaySubmitting] = useState(false);
  const [isActionBusy, setIsActionBusy] = useState(false);
  const actionDisabled = loading || isActionBusy || rowSelectionModel.length === 0;

  const BLOCKED_ACTION_BRANCH_IDS = [1]; // Vadapalani
  const BLOCKED_ACTION_BRANCH_NAMES = ['adminoffice'];

  const isBlockedBranchOrder = (row) => {
    const branchIdBlocked = BLOCKED_ACTION_BRANCH_IDS.includes(Number(row?.branchId));
    const branchNameBlocked = BLOCKED_ACTION_BRANCH_NAMES.includes(
      String(row?.branchName || '').trim().toLowerCase()
    );

    return branchIdBlocked || branchNameBlocked;
  };

  const timerRef = useRef(null);
  const resetTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      window.location.reload(); // Refresh the page
    }, 60000); // 1 minute = 60000ms
  };

  useEffect(() => {
    // List of events to listen for
    const events = ['mousemove', 'keydown', 'scroll', 'click'];

    // Set initial timer
    resetTimer();

    // Attach event listeners
    events.forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    // Cleanup
    return () => {
      clearTimeout(timerRef.current);
      events.forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, []);

  const selectedRows = rows.filter((row) =>
    rowSelectionModel.map(Number).includes(Number(row.id))
  );

  const hasBlockedSelectedOrder = selectedRows.some(isBlockedBranchOrder);
  const isConfirmOrPackAction = Number(curStatus) === 1 || Number(curStatus) === 2;
  const isVadapalaniActionBlocked = isConfirmOrPackAction && hasBlockedSelectedOrder;

  const finalActionDisabled = actionDisabled || isVadapalaniActionBlocked;

  const confirmClick = () => {
    if (finalActionDisabled) {
      if (isVadapalaniActionBlocked) {
        alert("Vadapalani branch order Confirm / Pack action is blocked from Admin.");
      }
      return;
    }
    if (actionDisabled) return;
    if (rowSelectionModel.length > 0) {
      showConfirm("Are you sure?", {
        description: constantType.orderButtonMessage[curStatus],
        type: "info",
      }).then((answer) => {
        if (answer) {
          handleSubmit();
        }
      });
    } else {
      alert("Kindly Select Order first");
    }
  };

  const confirmDeliveryClick = () => {
    if (actionDisabled) return;
    if (rowSelectionModel.length > 0) {
      showConfirm("Are you sure?", {
        description: constantType.orderButtonMessage[curStatus],
        type: "info",
      }).then((answer) => {
        if (answer) {
          deliveredOrderConfirm();
        }
      });
    } else {
      alert("Kindly Select Order first");
    }
  };

  const printPackageClick = () => {
    if (rowSelectionModel.length > 0) {
      setPrintInvoices(rowSelectionModel);
      setInvPrintModal(true);
    } else {
      alert("Kindly Select Order first");
    }
  };

  const cancelClick = () => {
    if (actionDisabled) return;
    if (rowSelectionModel.length > 0) {
      showConfirm("Are you sure?", {
        description: constantType.orderButtonMessage[3],
        type: "warning",
      }).then((answer) => {
        if (answer) {
          setOpenModal(true);
        }
      });
    } else {
      alert("Kindly Select Order first");
    }
  };

  const deliveredOrderConfirm = async () => {
    setIsActionBusy(true);
    try {
      const params = { status: curStatus, orderIds: rowSelectionModel, notes: "Confirmed" };
      const resp = await omsapi.updateDeliveredOrderConfirm(params);
      if (resp?.status === "SUCCESS") {
        showConfirm("Success", { description: "Process completed successfully", type: "Success", hideCancel: true })
          .then(() => {
            setRowSelectionModel([]);           // <-- clear selection
            setRefreshTable(prev => !prev);
          });
      } else {
        showConfirm("Oops!", { description: "Process failed, kindly try again later!.", type: "warning", hideCancel: true })
          .then(() => setRefreshTable(prev => !prev));
      }
    } finally {
      setIsActionBusy(false);
    }
  };

  const handleSubmit = async () => {
    setIsActionBusy(true);
    try {
      let params = { status: curStatus, orderIds: rowSelectionModel };
      if (curStatus === 1) params.status = 2;
      if (curStatus === 2) params.status = 4;
      const resp = await omsapi.updateOrder(params);
      if (resp?.status === "SUCCESS") {
        showConfirm("Success", { description: "Process completed successfully", type: "Success", hideCancel: true })
          .then(() => {
            setRowSelectionModel([]);           // <-- clear selection
            setRefreshTable(prev => !prev);
          });
      } else {
        showConfirm("Oops!", { description: "Process failed, kindly try again later!.", type: "warning", hideCancel: true })
          .then(() => setRefreshTable(prev => !prev));
      }
    } finally {
      setIsActionBusy(false);
    }
  };

  const validateCancelForm = () => {
    const newErrors = {};
    if (!closeNotes) newErrors.closeNotes = "Notes is required";
    return newErrors;
  };

  const validateDeliveryForm = () => {
    const newErrors = {};
    if (!handoverName) newErrors.handoverName = "Name is required";
    if (!handoverMob) newErrors.handoverMob = "Mobile number is required";
    if (!closeNotes) newErrors.closeNotes = "Notes is required";
    const zeroPayment = paymentFields.filter((i) => {
      return i.paymentValue === "" || parseInt(i.paymentValue) === 0 ? i.id : null;
    });
    if (zeroPayment && zeroPayment.length > 0) {
      newErrors.payment = zeroPayment.map((item) => {
        return { id: item.id, text: "Amount is required" };
      });
    }
    return newErrors;
  };

  const handleCancelOrder = async (event) => {
    event.preventDefault();
    const formErrors = validateCancelForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    setErrors({});
    setIsActionBusy(true);
    try {
      const params = { status: 3, orderIds: rowSelectionModel, notes: closeNotes };
      const resp = await omsapi.updateOrder(params);
      if (resp?.status === "SUCCESS") {
        // refresh & clear selection
        setRowSelectionModel([]);
        setRefreshTable((prev) => !prev);

        // Refund prompt only when exactly 1 order cancelled
        let showRefund = false;
        let orderIdToRefund = null;

        if (rowSelectionModel.length === 1) {
          const oid = Number(rowSelectionModel[0]);
          const selectedRow = rows.find((r) => Number(r.id) === oid);
          const txn = selectedRow?.paymentTxn || selectedRow?.payment_txn || null;

          const txnStatus = String(txn?.status || "").toUpperCase();

          const amountPaise = Number(txn?.amountPaise ?? txn?.amount_paise ?? 0);
          const refundedPaise = Number(
            txn?.refundedAmountPaise ??
            txn?.refunded_amount_paise ??
            txn?.refund_amount_paise ??
            0
          );

          const remainingPaise = amountPaise - refundedPaise;

          const isPaidSuccess = txnStatus === "SUCCESS";
          const isNotFullyRefunded = amountPaise > 0 && remainingPaise > 0;

          if (txn && isPaidSuccess && isNotFullyRefunded) {
            showRefund = true;
            orderIdToRefund = oid;
          }
        }

        if (showRefund && orderIdToRefund) {
          showConfirm("Order Cancelled", {
            description: "Payment already received. Do you want to refund now?",
            type: "info",
            confirmText: "Refund Now",
            cancelText: "Later",
          }).then((ans) => {
            if (ans) {
              // redirect to refund create page (same tab)
              window.location.assign(`/admin/payments/refunds/create?orderId=${orderIdToRefund}`);
            }
          });
        } else {
          // Normal success popup
          showConfirm("Success", {
            description: "Orders Cancelled successfully",
            type: "Success",
            hideCancel: true,
          });
        }
      } else {
        showConfirm("Oops!", { description: "Process failed, kindly try again later!.", type: "warning", hideCancel: true })
          .then(() => setRefreshTable(prev => !prev));
      }
      handleClose();
    } catch {
      setErrors({ common: "Update Failed" });
    } finally {
      setIsActionBusy(false);
    }
  };

  const handleDeliveryConfirm = async (event) => {
    setErrors({});
    event.preventDefault();
    const formErrors = validateDeliveryForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      try {
        setIsTakeawaySubmitting(true);
        const payments = [];
        paymentFields.map((pay) =>
          payments.push({
            paymentType: parseInt(pay.paymentModeValue),
            paidAmount: parseFloat(pay.paymentValue),
          })
        );
        const totalPaid = await calculateCurrentTotal();
        if (totalPaid === parseFloat(invoiceAllowAmount)) {
          let params = {
            status: 6,
            orderId: orderData.id,
            notes: closeNotes,
            handoverName,
            handoverMob,
            payments: [...payments],
          };
          // console.log(params,'Params');
          const resp = await omsapi.updateTakeawayOrder(params);
          // console.log(resp, "respresp");
          if (resp && resp.status === "SUCCESS") {
            // console.log('Inside comming');
            if (resp && resp.status === "SUCCESS") {
              showConfirm("Success", {
                description: "Order has been updated successfully.",
                type: "success",
                hideCancel: true,
              });
              resetTakeawayDeliveryForm();
              setRefreshTable(prev => !prev);
              handleClose();
            }
          } else {
            handleClose();
            showConfirm("Oops!", {
              description: "Order has not been updated.",
              type: "warning",
              hideCancel: true,
            });
          }
        } else {
          setErrors({ common: "Payment not matched" });
        }
      } catch (error) {
        setErrors({ common: "Update Failed" });
      } finally {
        setIsTakeawaySubmitting(false); // Stop loader in all cases
      }
    }
  };

  const resetTakeawayDeliveryForm = () => {
    setHandoverName('');
    setHandoverMob('');
    setReason({ target: { value: '' } }); // assuming setReason mimics event handler
    setPaymentFields([{ paymentModeValue: '', paymentValue: '' }]); // reset to one empty field
    setErrors({});
  };
  const remapOrder = async (row) => {
    const params = {
      status: 4, // always remapping to status 4
      orderIds: [row.row.id], // assuming `id` is the order ID
    };

    try {
      const resp = await omsapi.updateOrder(params);
      if (resp && resp.status === "SUCCESS") {
        showConfirm("Remapped", {
          description: "Order has been successfully remapped to Delivery App.",
          type: "success",
          hideCancel: true,
        }).then(() => {
          setRefreshTable(prev => !prev);
        });
      } else {
        showConfirm("Oops!", {
          description: "Remapping failed. Please try again later.",
          type: "warning",
          hideCancel: true,
        });
      }
    } catch (error) {
      console.error("Remap failed:", error);
      showConfirm("Error", {
        description: "An error occurred while remapping the order.",
        type: "error",
        hideCancel: true,
      });
    }
  };
  const createSaleOrder = async (row) => {
    const params = {
      orderId: row.row.id, // assuming `id` is the order ID
    };

    try {
      const resp = await omsapi.createSaleOrder(params);
      if (resp && resp.status === "SUCCESS") {
        showConfirm("Success", {
          description: "Sale Order has been successfully synced with Gofrugal.",
          type: "success",
          hideCancel: true,
        }).then(() => {
          setRefreshTable(prev => !prev);
        });
      } else {
        showConfirm("Oops!", {
          description: "Sale Order sync failed. Please try again later.",
          type: "warning",
          hideCancel: true,
        });
      }
    } catch (error) {
      console.error("Remap failed:", error);
      showConfirm("Error", {
        description: "An error occurred while remapping the order.",
        type: "error",
        hideCancel: true,
      });
    }
  };

  const triggerFilter = () => {
    setPaginationModel((prev) =>
      prev.page === 0 ? prev : { ...prev, page: 0 }
    );
    setRefreshTable((prev) => !prev);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    triggerFilter();
  };

  useEffect(() => {
    setRowSelectionModel([]);
  }, [refreshTable]);

  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const brachList = await branchApi.getAllBranches({ status: 1 });
        const branchSorted = brachList.data.result.sort((a, b) =>
          a.branchName.localeCompare(b.branchName)
        );
        setAllBranches(branchSorted);
        let getBranchDet = brachList.data.result.filter((val) =>
          val.branchId === branchId ? val : null
        );
        if (getBranchDet.length > 0) {
          setBranchName(getBranchDet[0].branchName || branchName);
          setboxBranchName(getBranchDet[0].branchName || branchName);
        }
      } catch (e) {
        console.error("Failed to fetch branch:", e);
      }
    };
    fetchBranch();
  }, []);

  const PLACED_TYPE_LABELS = { 1: 'Web', 2: 'App', 3: 'iOS', 4: 'Android' };

  const PLACED_TYPE_COLORS = {
    Web: '#f59e0b', // orange
    App: '#22c55e', // green
    iOS: '#3b82f6', // blue
    Android: '#16a34a', // green
  };

  const Badge = ({ label }) => {
    if (!label) return null;
    const bg = PLACED_TYPE_COLORS[label] ?? '#6b7280';
    return (
      <span
        style={{
          backgroundColor: bg,
          color: '#fff',
          padding: '2px 8px',
          borderRadius: '9999px',
          fontSize: 11,
          fontWeight: 600,
          lineHeight: 1,
          display: 'inline-block',
        }}
      >
        {label.toUpperCase()}
      </span>
    );
  };

  const columns = useMemo(() => [
    { field: "orderNo", headerName: "Order No", flex: 1 },
    { field: "date", headerName: "Order Placed ON", flex: 1 },
    { field: "branchName", headerName: "Branch", flex: 1 },
    {
      field: "customerName",
      headerName: "Customer Name",
      flex: 1,
    },
    {
      field: "customerMob",
      headerName: "Mobile",
      flex: 1,
    },
    { field: "noOfProducts", headerName: "No Of Products" },
    { field: "orderValue", headerName: "Order Value", flex: 1 },
    {
      field: "liveStatus",
      headerName: "Live Status",
      flex: 1,
      renderCell: (row) => {
        const isPacked = curStatus === 4;
        const isConfirmed = curStatus === 2;
        const isMapped = parseInt(row.row.delivery_order_value) === 1;
        const isDeliveryApp = row.row.deliTypeId !== 3;
        const gofrugalId = parseInt(row.row.gofrugal_id);
        if (isPacked) {
          return (
            <div className="d-flex flex-column">
              <small className="text-primary fw-bold">Packed</small>
              {isDeliveryApp && (
                <div className="d-flex align-items-center mt-1">
                  {isMapped ? (
                    <small className="text-success">Mapped</small>
                  ) : (
                    <>
                      <small className="text-danger me-2">Not Mapped</small>
                      <Button
                        variant="outline-warning"
                        size="sm"
                        className="p-1"
                        onClick={() => remapOrder(row)}
                      >
                        <FontAwesomeIcon icon="fa-solid fa-rotate" />
                      </Button>
                    </>
                  )}
                </div>
              )}
            </div>
          );
        }
        if (isConfirmed) {
          return (
            <div className="d-flex flex-column">
              <small className="text-primary fw-bold">Confirmed</small>

              <div className="d-flex align-items-center mt-1">
                {gofrugalId === 0 ? (
                  <>
                    <small className="text-danger me-2">Sync SO</small>
                    <Button
                      variant="outline-warning"
                      size="sm"
                      className="p-1"
                      onClick={() => createSaleOrder(row)}
                    >
                      <FontAwesomeIcon icon="fa-solid fa-rotate" />
                    </Button>
                  </>
                ) : (
                  <small className="text-success me-2">SO Synced</small>
                )}
              </div>
            </div>
          );
        }
        const placedType = Number(row.row?.placedType);
        const label = PLACED_TYPE_LABELS[placedType] ?? '';
        const liveStatus = row.row?.liveStatus ?? '-';

        return (
          <small>
            {liveStatus}
            {label && (
              <>
                <br />
                <Badge label={label} />
              </>
            )}
          </small>
        );
      }
    },
    { field: "deliType", headerName: "Delivery Type", flex: 1 },
    // { field: "orderType", headerName: "Date", flex: 1 },
    { field: "deliSlot", headerName: "Expected Deli Date", flex: 1 },
    {
      field: "payment",
      headerName: "Payment",
      flex: 1,
      renderCell: (row) => {
        const label = row.row.payment || "-";
        const txn = row.row.paymentTxn || row.row.payment_txn || null;

        if (!txn) return <small>{label}</small>;

        const tip = (
          <div style={{ fontSize: 12, lineHeight: 1.4 }}>
            <div><b>Txn ID:</b> {txn.id}</div>
            <div><b>Status:</b> {txn.status}</div>
            <div><b>PG Order:</b> {txn.pgOrderId || "-"}</div>
            <div><b>PG Payment:</b> {txn.pgPaymentId || "-"}</div>
            <div><b>Amount:</b> {(Number(txn.amountPaise || 0) / 100).toFixed(2)}</div>
            <div><b>Refunded:</b> {(Number(txn.refundedAmountPaise || 0) / 100).toFixed(2)}</div>
          </div>
        );

        return (
          <Tooltip title={tip} placement="top" arrow>
            <span style={{ cursor: "help", textDecoration: "underline dotted" }}>
              {label}
            </span>
          </Tooltip>
        );
      }
    },
    {
      field: "action",
      headerName: "Action",
      disableClickEventBubbling: true,
      renderCell: (row) => {
        return (
          <>
            <Col>
              <Button
                className={"p-2 me-2 mb-1 "}
                size="sm"
                onClick={() => openInvoice(row)}
              >
                <FontAwesomeIcon
                  icon="fa-solid fa-eye"
                  size="sm"
                  style={{ color: "black" }}
                />{" "}
                View
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                className="p-1"
                title="View History"
                onClick={() => {
                  const url = `/admin/orders/${row.id}/history`;
                  window.open(url, "_blank", "noopener,noreferrer");
                }}
              >
                <FontAwesomeIcon icon="fa-solid fa-clock-rotate-left" />
              </Button>
              {Number(row.row.deliTypeId) === 3 && Number(curStatus) === 4 && (
                <Button
                  variant="success"
                  className={"p-1"}
                  size="sm"
                  onClick={() => confirmDelivery(row)}
                >
                  Confirm Delivery
                </Button>
              )}
            </Col>
          </>
        );
      },
      flex: 1,
    },
  ], [curStatus]);

  const openInvoice = (row) => {
    if (row.id !== null) {
      setInvoiceId(row.id);
      setInvModal(true);
    }
  };

  const confirmDelivery = (row) => {
    if (row.id !== null) {
      setOpenModal(true);
      setDeliBoxEnable(true);
      setModelContent({
        title: "Confirm Delivery",
        buttonText: "Confirm Delivery",
        handleChangeType: "deliconfirm",
      });
      setDelInvoiceId(row.id);
      setNotesText("Notes");
      setInvoiceAllowAmount(row.row.orderValue);
      setCurrentPaymentAmount(0);
      setOrderData({ ...row.row });
    }
  };

  const hideInvoiceModal = () => {
    setInvoiceId(0);
    setInvModal(false);
  };

  const hidePrintInvoiceModal = () => {
    setPrintInvoices([]);
    setInvPrintModal(false);
  };

  useEffect(() => {
    setRowSelectionModel([]);
  }, [curStatus, curActive]);

  useEffect(() => {
    if (!curActive) return;

    const fetchOrders = async () => {
      setLoading(true);
      try {
        const { page, pageSize } = paginationModel;
        if (pushUrl) {
          history.push(`${pushUrl}`);
        }

        const data = await omsapi.getAllOrders({
          limit: pageSize,
          page,
          branchId,
          status: curStatus,
          action: curAction,
          search: searchKey,
          deliveryType: deliveryType || null,
          placedType: placedType || null,
          paymentTypes: paymentTypes.join(",") || undefined,
          fromDate,
          toDate,
          dateFilterField,
          needImage: false,
          needShippingAddress: false
        });

        // Prioritize deliTypeId 2 and 4 first, then sort the rest
        const sortedOrders = data.data.result.sort((a, b) => {
          if (a.order_deliverytype === 2 || a.order_deliverytype === 4) {
            return -1; // Bring 2 and 4 to the front
          } else if (b.order_deliverytype === 2 || b.order_deliverytype === 4) {
            return 1; // Move the other rows down
          }
          return 0; // No change for other types
        });

        const formattedRows = sortedOrders.map((order) => {
          const dateShow = {
            3: order.order_cancelleddate,
            5: order.order_shippeddate,
            6: order.order_delivereddate,
          }[curStatus] || order.order_deliverydate;
          const deliverySlot = order.order_deliverydate
            ? `${moment(order.order_deliverydate).format('YYYY/MM/DD')} ${moment(order.order_deliveryfmtime, 'HH:mm:ss').format('hh:mm A')} - ${moment(order.order_deliverytotime, 'HH:mm:ss').format('hh:mm A')}`
            : '';
          return {
            id: order.id,
            orderNo: order.order_showid,
            date: order.order_deliverydate
              ? moment(order.order_posteddate).format("YYYY/MM/DD hh:mm:ss A")
              : "",
            noOfProducts: order.order_itemcount,
            customerDetails: {
              name: order.customer_name,
              mobile: order.mobile,
            },
            customerName: order.customer_name,
            customerMob: order.mobile,
            branchId: order.order_branchid,
            branchName: order.branch_name,
            orderValue: order.order_totalamnt,
            placedType: order.order_placedtype,
            liveStatus:
              data.OrderStatusData[order.order_status] || "Unknown Status",
            deliType:
              constantType.deliveryTypes[order.order_deliverytype] ||
              "Not Defined",
            orderType: dateShow
              ? moment(dateShow).format("YYYY/MM/DD kk:mm:ss")
              : "",
            deliSlot: deliverySlot,
            payment: constantType.payemntTypes[order.order_paytype] || "Unknown",
            deliTypeId: order.order_deliverytype,
            delivery_order_value: order.delivery_order_value || 0,
            gofrugal_id: order.gofrugal_id || '0',
            paymentTxn: order.payment_txn || null,
          };
        });

        setRows(formattedRows);
        setTotalOrders(data.data.totalRecords || 0);
      } catch (error) {
        console.error("Failed to fetch orders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [curActive, curStatus, branchId, refreshTable, paginationModel]);

  const extraoption = { branchId: 0, branchName: "All" };
  const pathArray = [
    {
      name: "OMS",
      url: "/admin/order",
    },
    {
      name: constantType.orderStatus[curStatus],
      url: null,
    },
  ];

  const handleClose = () => {
    setOpenModal(false);
    setDeliBoxEnable(false);
    setModelContent({
      title: "Update the Reason",
      buttonText: "Cancel Order",
      handleChangeType: "cancel",
    });
    setNotesText("Enter Reason");
  };



  const handleSelect = (key) => {
    setCurActive(key);
    setCurAction("");
    if (key === "ALL") {
      setCurStatus(0);
      setPushUrl("/admin/orders/all");
    } else if (key === "confirmed") {
      setCurStatus(2);
      setPushUrl("/admin/orders/confirmed");
    } else if (key === "pending") {
      setPushUrl("/admin/orders/pending");
      setCurStatus(1);
    } else if (key === "packed") {
      setPushUrl("/admin/orders/packed");
      setCurStatus(4);
    } else if (key === "shipped") {
      setPushUrl("/admin/orders/shipped");
      setCurStatus(5);
    } else if (key === "delivered") {
      setPushUrl("/admin/orders/delivered");
      setCurStatus(6);
    } else if (key === "cancelled") {
      setPushUrl("/admin/orders/cancelled");
      setCurStatus(3);
    } else if (key === "deliconfirm") {
      setPushUrl("/admin/orders/delivery-confirm");
      setCurAction("confirmed");
      setCurStatus(6);
    }
  };

  const setReason = (e) => {
    setCloseNotes(e.target.value);
  };

  const addInput = () => {
    setPaymentFields((s) => {
      return [
        ...s,
        {
          id: s.length + 1,
          paymentModeValue: 0,
          paymentValue: "",
        },
      ];
    });
  };

  const handlePaymentChange = (e) => {
    e.preventDefault();
    let id = e.target.id;
    let idArr = id.split("paymentAmount");
    const index = idArr[1] ?? "";
    if (index) {
      setPaymentFields((s) => {
        const newArr = s.slice();
        newArr[index].paymentValue = e.target.value;
        return newArr;
      });
    }
  };

  const calculateCurrentTotal = () => {
    const paidTotal = paymentFields.reduce(
      (totalPaid, paymentFields) =>
        totalPaid + parseFloat(paymentFields.paymentValue),
      0
    );
    return paidTotal;
  };

  const handlePaymentModeChange = (e) => {
    e.preventDefault();
    let id = e.target.id;
    let idArr = id.split("paymentMode");
    const index = idArr[1] ?? "";
    if (index) {
      setPaymentFields((s) => {
        const newArr = s.slice();
        newArr[index].paymentModeValue = e.target.value;
        return newArr;
      });
    }
  };

  const removePayment = async (id) => {
    if (id) {
      let payfield = paymentFields.filter((item) => {
        return item.id !== id;
      });
      setPaymentFields([...payfield]);
    }
  };

  useEffect(() => {
    paymentFields.map((item, i) => {
      return (item.id = i + 1);
    });
  }, [paymentFields]);

  const paymentOptions = ["Cash", "Card", "UPI"];
  // console.log(roleId,"roleId");
  // Map over Payment Fields
  const renderPaymentFields = () => {
    return paymentFields?.map((item, i) => {
      const payError = errors.payment?.find((e) => e.id === item.id);
      return (
        <Row className="mb-3" key={item.id}>
          <OrderPayFields
            index={i}
            item={item}
            paymentOptions={paymentOptions}
            payError={payError}
            handlePaymentModeChange={handlePaymentModeChange}
            handlePaymentChange={handlePaymentChange}
            removePayment={removePayment}
          />
        </Row>
      );
    });
  };
  const HIDDEN_ROLES = new Set([3, 4, 5, 6, 13]);
  return (
    <Container className="mt-4 mb-4">
      <DynamicBreadcrumb pathArray={pathArray} />
      <OrderTabs curActive={curActive} handleSelect={handleSelect} totalOrders={totalOrders} />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>ORDERS - {branchName}</h5>
        {!HIDDEN_ROLES.has(Number(roleId)) && (
          <SearchableDropdown
            options={allBranches}
            extraoption={extraoption}
            label="branchName"
            id="branchId"
            selectedVal={boxBranchName}
            handleChange={({ id = null, name = null }) => {
              setBranchID(id);
              if (name) setBranchName(name);
              setboxBranchName(name);
            }}
          />
        )}
        {/* <OrderButtons curStatus={curStatus} curAction={curAction} cancelClick={cancelClick} printPackageClick={printPackageClick} confirmClick={confirmClick} buttonName={buttonName} confirmDeliveryClick={confirmDeliveryClick} roleId={roleId} disabled={actionDisabled} /> */}
        <OrderButtons
          curStatus={curStatus}
          curAction={curAction}
          cancelClick={cancelClick}
          printPackageClick={printPackageClick}
          confirmClick={confirmClick}
          buttonName={buttonName}
          confirmDeliveryClick={confirmDeliveryClick}
          roleId={roleId}
          disabled={finalActionDisabled}
        />
      </div>

      <Col>
        <Form className="d-flex flex-wrap gap-3 mb-3 align-items-end" onSubmit={handleFormSubmit}>
          <Form.Group controlId="searchKey">
            <Form.Label>Search</Form.Label>
            <Form.Control
              type="text"
              placeholder="Order No, Name or Mobile"
              value={searchKey}
              onChange={(e) => setSearchKey(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  triggerFilter();
                }
              }}
            />
          </Form.Group>

          <Form.Group controlId="deliveryType">
            <Form.Label>Delivery Type</Form.Label>
            <Form.Select
              value={deliveryType}
              onChange={(e) => setDeliveryType(e.target.value)}
            >
              <option value="">All Delivery Types</option>
              {Object.entries(constantType.deliveryTypes).map(([id, name]) => (
                <option key={id} value={id}>
                  {name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group controlId="placedType">
            <Form.Label>Order Source</Form.Label>

            <Form.Select
              value={placedType}
              onChange={(e) => setPlacedType(e.target.value)}
            >
              <option value="">All Sources</option>
              <option value="1">Web</option>
              <option value="2">Mobile App</option>
              <option value="3">iOS App</option>
              <option value="4">Android App</option>
            </Form.Select>
          </Form.Group>

          <fieldset className="border rounded px-3 py-2" style={{ minWidth: 230 }}>
            <legend className="float-none w-auto px-1 fs-6 mb-1">Payment type</legend>
            <div className="d-flex flex-wrap gap-3">
              {[["1", "COD"], ["2", "Card on delivery"], ["4", "Online payment"]].map(([value, label]) => (
                <Form.Check key={value} id={`payment-filter-${value}`} label={label}
                  checked={paymentTypes.includes(value)}
                  onChange={e => setPaymentTypes(types => e.target.checked ? [...types, value] : types.filter(type => type !== value))} />
              ))}
            </div>
            <div className="small text-muted">{paymentTypes.length ? "Matches any selected payment type" : "All payment types"}</div>
          </fieldset>

          <Form.Group controlId="dateFilterField">
            <Form.Label>Filter By</Form.Label>
            <Form.Select
              value={dateFilterField}
              onChange={(e) => setDateFilterField(e.target.value)}
            >
              <option value="order_posteddate">Order Placed</option>
              <option value="order_delivereddate">Delivered</option>
              <option value="order_cancelleddate">Cancelled</option>
              <option value="order_shippeddate">Shipped</option>
              <option value="order_packeddate">Packed</option>
              <option value="delivery_confirmeddate">Delivery Confirmed</option>
            </Form.Select>
          </Form.Group>

          <Form.Group controlId="fromDate">
            <Form.Label>From</Form.Label>
            <Form.Control
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="toDate">
            <Form.Label>To</Form.Label>
            <Form.Control
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Form.Group>

          <div className="d-flex gap-2">
            <Button variant="primary" type="button" onClick={triggerFilter}>
              Filter
            </Button>
            <Button
              variant="secondary"
              type="button"
              onClick={() => {
                setSearchKey("");
                setDeliveryType("");
                setPlacedType("");
                setPaymentTypes([]);
                setFromDate("");
                setToDate("");
                setDateFilterField("order_posteddate");
                triggerFilter();
              }}
            >
              Reset
            </Button>
          </div>
        </Form>
      </Col>
      <Box>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowHeight={() => "auto"}
          rowsPerPageOptions={[5, 10, 20]}
          paginationMode="server"
          rowCount={totalOrders}
          loading={loading}
          checkboxSelection
          disableRowSelectionOnClick
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          autosizeOptions={{
            columns: ["payment", "customerName", "deliType"],
            includeOutliers: true,
            includeHeaders: false,
          }}
          slots={{
            toolbar: GridToolbar,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              printOptions: { disableToolbarButton: true },
              csvOptions: { disableToolbarButton: true },
            },
          }}
          onRowSelectionModelChange={(row) => {
            setRowSelectionModel(row);
          }}
          rowSelectionModel={rowSelectionModel}
          sx={{
            [`& .${gridClasses.cell}`]: {
              py: 0.5,
            },
          }}
          getRowClassName={(params) => {
            // Check if deliTypeId is 3, then apply the 'red-row' class
            if (params.row.deliTypeId === 4) {
              return 'orange-row'; // Apply the red background
            }
            else if (params.row.deliTypeId === 2) {
              return 'red-row'; // Apply the red background
            }
            return ''; // Default (no special class)
          }}
        />
      </Box>

      {invoiceId > 0 && (
        <InvoiceModal
          invoiceId={invoiceId}
          invModal={invModal}
          change={hideInvoiceModal}
        />
      )}

      {openModal && <OrderModal
        openModal={openModal}
        handleClose={handleClose}
        modelContent={modelContent}
        orderData={orderData}
        invoiceAllowAmount={invoiceAllowAmount}
        errors={errors}
        deliBoxEnable={deliBoxEnable}
        handoverName={handoverName}
        setHandoverName={setHandoverName}
        handoverMob={handoverMob}
        setHandoverMob={setHandoverMob}
        paymentFields={paymentFields}
        renderPaymentFields={renderPaymentFields}
        addInput={addInput}
        closeNotes={closeNotes}
        setReason={setReason}
        handleCancelOrder={handleCancelOrder}
        handleDeliveryConfirm={handleDeliveryConfirm}
        notesText={notesText}
        isSubmitting={
          modelContent.handleChangeType === "deliconfirm"
            ? isTakeawaySubmitting
            : isActionBusy
        }
      />}

      {printInvoices.length > 0 && (
        <InvoicePrintModal
          invoiceId={printInvoices}
          invPrintModal={invPrintModal}
          change={hidePrintInvoiceModal}
        />
      )}
    </Container>
  );
};

export default OrderTable;

